import { SEO } from "@/components/SEO";
import { WorkWithMeHero }         from "../components/site/work-with-me/WorkWithMeHero";
import { MaybeYoureHere }         from "../components/site/work-with-me/MaybeYoureHere";
import { WorkTogether }           from "../components/site/work-with-me/WorkTogether";
import { OffersIntro }            from "../components/site/work-with-me/OffersIntro";
import { InsideExperience }       from "../components/site/work-with-me/InsideExperience";
import { WorkWithMeTestimonials } from "../components/site/work-with-me/WorkWithMeTestimonials";
import { WorkWithMeCTA }          from "../components/site/work-with-me/WorkWithMeCTA";

export default function WorkWithMe() {
  return (
    <div data-testid="work-with-me-page">
      <SEO
        title="Work With Me"
        description="Coaching pathways with Lara Parrish — from Spark Sessions to Consistency Corner — built for people ready to build momentum, one small step at a time."
        path="/work-with-me"
      />
      <WorkWithMeHero />
      <MaybeYoureHere />
      <WorkTogether />
      <OffersIntro />
      <InsideExperience />
      <WorkWithMeTestimonials />
      <WorkWithMeCTA />
    </div>
  );
}
